export const typesContinent = {
    Africa: 'Africa',
    America: 'America',
    Asia: 'Asia',
    Europe: 'Europe',
    Oceania: 'Oceania',
};
